import styles from "./InitSitePreloader.module.scss";
import {cn} from "@/utils/cn.ts";

/**
 * Прелоадер первичной загрузки сайта
 * @param isLoading - Индикатор загрузки сайта
 * @constructor
 */
export const InitSitePreloader = ({isLoading}: { isLoading: boolean }) => {
    return (
        <div className={styles.cover}>
            <div className={cn(styles.container, !isLoading && styles.container__open)}>
                <span className={styles.loader}></span>
            </div>
        </div>
    );
};
